export const FinancialAssetSubType = {
  FUND_EQUITY: "FUND_EQUITY",
  FUND_BALANCED: "FUND_BALANCED",
  FUND_FIXED_INCOME: "FUND_FIXED_INCOME",
};

export const FinancialAssetSubTypeFarsi = {
  FUND_EQUITY: "سهامی",
  FUND_BALANCED: "مختلط",
  FUND_FIXED_INCOME: "درآمد ثابت",
};
